/*
 * @Author: linbin@leedarson.com
 * @Date: 2022-10-18 09:17:57
 * Copyright © Leedarson. All rights reserved.
 */

import { ILogRecord, ILogRecordContext } from './types';
import convert from './convert';
import builder from './builder';
import upload from './upload';

class Report {
  id: string;
  startTimestamp: number;
  stepTimestamp: number;
  record: ILogRecord;
  static instances: Record<string, Report> = {};

  constructor(id: string) {
    const now = Date.now();
    this.id = id;
    this.startTimestamp = now;
    this.stepTimestamp = now;
    this.record = {} as ILogRecord;
  }

  static uuid() {
    return `${Date.now()}${Math.floor(Math.random() * 1000)}`;
  }

  // 不存在就创建
  static getInstance(id?: string) {
    const key = id || Report.uuid();
    let instance = Report.instances[key];
    if (!instance) {
      instance = new Report(key);
      Report.instances[key] = instance;
    }
    return instance;
  }

  static isExist(id: string) {
    return !!Report.instances[id];
  }

  static upload(record: ILogRecord) {
    const { hostname } = window.location;
    if (
      ['localhost', '127.0.0.1', 'dev-payment.arnoo.com'].includes(hostname)
    ) {
      return;
    }
    const formatRecord = convert(record);
    const finalRecord = builder(formatRecord);
    upload(finalRecord);
  }

  pushMessage(stepMessage: Record<string, any>) {
    const now = Date.now();
    if (Array.isArray(this.record.message)) {
      stepMessage.time = now - this.stepTimestamp;
      this.record.message.push(stepMessage);
    } else {
      this.record.message = [stepMessage];
    }
    this.stepTimestamp = now;
    return this;
  }

  addFirstField(firstField: object) {
    this.record = { ...this.record, ...firstField };
    return this;
  }

  hoistTimeAlias(key: string) {
    this.record[key] = this.record.message[this.record.message.length - 1].time;
    return this;
  }

  uploadContext(record: ILogRecordContext) {
    if (record.message) {
      this.pushMessage(record.message);
      delete record.message;
    }
    this.record = {
      timeTotal: Date.now() - this.startTimestamp,
      ...this.record,
      ...record,
    };
    Report.upload(this.record as ILogRecord);
    delete Report.instances[this.id];
  }
}

// // 1. 直接上报
// Report.upload({ level: 'debug', module: 'MQTT', event: 'x', message: 123 });
// // 2. 上下文 - 传参数
// const r = Report.getInstance();
// r.pushMessage({ step: 'first' }).addFirstField({ xxxTime: 123 });
// r.pushMessage({ step: 'last' }).uploadContext({ level: 'debug', module: 'MQTT', event: 'x' });
// // 3. 上下文 - 跨页面
// const id = Report.uuid();
// const r1 = Report.getInstance(id);
// r1.pushMessage({ step: 'first' }).addFirstField({ xxxTime: 123 });
// const r2 = Report.getInstance(id); // 跳转页面后, 根据id查找实例
// r2.pushMessage({ step: 'last' }).uploadContext({ level: 'debug', module: 'MQTT', event: 'x' });

export default Report;
